/** Spec 036 P10: auto-generated indicator names (handoff 4.5). */
import type { ParamValue } from './types'

const SESSION_LABELS: Array<[string, string]> = [
  ['asia', 'Asia'],
  ['london', 'London'],
  ['new_york', 'NY'],
]

/** `SMA 20`, `EMA 50`, `BB 20 · 2`, `Pivots · day`, `Sessions · Asia/London/NY`, `FVG ≥ 0 ticks`, `IFVG ≥ 0 ticks`, `Levels · swing 2`, `Sweeps · swing 2`. */
export function indicatorName(type: string, p: Record<string, ParamValue>): string {
  switch (type) {
    case 'sma':
      return `SMA ${p.period}`
    case 'ema':
      return `EMA ${p.period}`
    case 'bb':
      return `BB ${p.period} · ${p.mult}`
    case 'pivots':
      return `Pivots · ${p.period}`
    case 'session': {
      const on = SESSION_LABELS.filter(([key]) => p[key] !== false).map(([, label]) => label)
      return `Sessions · ${on.length > 0 ? on.join('/') : 'none'}`
    }
    case 'fvg':
      return `FVG ≥ ${p.min_gap_ticks} ticks`
    case 'ifvg':
      return `IFVG ≥ ${p.min_gap_ticks} ticks`
    case 'levels':
      return `Levels · swing ${p.swing_length}`
    case 'sweeps':
      return `Sweeps · swing ${p.swing_length}`
    default:
      return type.toUpperCase()
  }
}

/**
 * The rail row's second line: `{Type} · {param values}` (handoff 4.4). A bool
 * contributes its param name when true and nothing when false; values are
 * joined with ` / `.
 */
export function indicatorMeta(
  def: { label: string; params: Array<{ name: string }> } | undefined,
  type: string,
  p: Record<string, ParamValue>,
): string {
  const label = def?.label ?? type.toUpperCase()
  const names = def?.params.map((d) => d.name) ?? Object.keys(p)
  const parts = names
    .map((n) => (typeof p[n] === 'boolean' ? (p[n] ? n : '') : String(p[n] ?? '')))
    .filter((v) => v !== '')
  return parts.length > 0 ? `${label} · ${parts.join(' / ')}` : label
}
